import { FC, HTMLAttributes, PropsWithChildren } from 'react';

import { ModalProps } from '@/hooks/use-modal';

import { ModalAlert } from './modal-alert';
import { ModalBody } from './modal-body';
import { ModalFooter } from './modal-footer';
import { ModalLayout } from './modal-layout';
import { ModalTitle } from './modal-title';

interface ModalComponentProps extends PropsWithChildren<ModalProps> {
  /**
   * Prevent modal from closing during loading states
   */
  preventClose?: boolean;
  hideCloseIcon?: boolean;
}

const ModalComponent: FC<ModalComponentProps & HTMLAttributes<HTMLDivElement>> = ({
  children,
  preventClose = false,
  onClose,
  ...layoutProps
}) => {
  const handleClose = () => {
    // Prevent closing if preventClose is true
    if (preventClose) return;
    onClose();
  };

  return (
    <ModalLayout {...layoutProps} onClose={handleClose}>
      {children}
    </ModalLayout>
  );
};

export const Modal = Object.assign(ModalComponent, {
  Title: ModalTitle,
  Alert: ModalAlert,
  Body: ModalBody,
  Footer: ModalFooter,
});
